import * as React from 'react';
import Stack from '@mui/material/Stack';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import RuleFolderOutlinedIcon from '@mui/icons-material/RuleFolderOutlined';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import OpenFileDialog from '../components/OpenFileDialog';
import * as ATCAConstants from '../util/ATCAConstants'
import CreateFileDialog from '../components/CreateFileDialog';
import { useNavigate, createSearchParams } from 'react-router-dom';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import PrivacyNoticeDialog from '../components/PrivacyNoticeDialog';
import ValidateScheduleDialog from '../components/ValidateScheduleDialog';
import TheaterComedyOutlinedIcon from '@mui/icons-material/TheaterComedyOutlined';
import ScheduleConverterDialog from '../components/ScheduleConverterDialog';

export default function Project() {
  const navigate = useNavigate();

  const [openCreateProjectFileDialog, setOpenCreateProjectFileDialog] = React.useState(false);
  const [openProjectFileDialog, setOpenProjectFileDialog] = React.useState(false);
  const [openPrivacyNoticeDialog, setOpenPrivacyNoticeDialog] = React.useState(false);
  const [openValidateDialog, setOpenValidateDialog] = React.useState(false);
  const [openConverterDialog, setOpenConverterDialog] = React.useState(false);
  
  const handlePrivacyMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPrivacyNoticeDialog(true);
  };

  const handleClosePrivacyNotice = () => {
    setOpenPrivacyNoticeDialog(false);
  };


  const createProject = () => {
    setOpenCreateProjectFileDialog(true);
  }

  const openProject = () => {
    setOpenProjectFileDialog(true);
  }

  const handleCancelOpenProject = () => {
    setOpenProjectFileDialog(false);
  }

  const handleOpenValidateScheduleDialog = () => {
    setOpenValidateDialog(true);
  }

  const handleOpenConvertScheduleDialog = () => {
    setOpenConverterDialog(true);
  }

  const handleProject = (fullname: string) => {    
    if (fullname) {
      setOpenCreateProjectFileDialog(false);
      const param = createSearchParams({ project: fullname });
      navigate({pathname: 'target-catalogue', 
        search: `?${param}`});
    }
  }

  const handleCancelCreateProject = () => {
    setOpenCreateProjectFileDialog(false);
  }

  const itemCreateSelectionAllowed = (item: any) => {
    if (item) {
      if (item['is_directory']) {
        if (item['children']) {
          const projectFile = item['children'].filter(
            (file: any) => { return file['name'] === ATCAConstants.PROJECT_FILENAME }
          );
          return (projectFile.length === 0);
        }
      }
    }

    return false;
  }

  const itemSelectionAllowed = (item: any) => {
    if (item) {
      if (item['is_directory']) {
        if (item['children']) {
          const projectFile = item['children'].filter(
            (file: any) => { return file['name'] === ATCAConstants.PROJECT_FILENAME }
          );
          return (projectFile.length > 0);
        }
      }
    }

    return false;
  }

  return (
    <Stack direction={'row'} sx={{width: '100%', height: 'calc(100vh - 150px)'}}>
      <ValidateScheduleDialog
        open={openValidateDialog}
        handleCancel={() => setOpenValidateDialog(false)}
      />

      <ScheduleConverterDialog
        open={openConverterDialog}
        handleCancel={() => setOpenConverterDialog(false)}
      />


      <Stack sx={{
          padding: '20px',
          justifyContent: 'center'
        }}>
        <img width={'700px'}
          src='./atca_image.jpg'
          alt=''
        />
      </Stack>
      <Stack spacing={2} 
        sx={{padding: '10px', 
            width: '40%',
            justifyContent: 'center'}}>

        <Typography variant="h2" color='primary' textAlign={'center'} gutterBottom>
          Welcome
        </Typography>
        <Button variant="text" size='large'
          startIcon={<CreateNewFolderOutlinedIcon />}
          onClick={createProject}>
          Create Project
        </Button>

        <Button variant="text" size='large'
          startIcon={<FolderOpenOutlinedIcon />}
          onClick={openProject}>
          Open Project
        </Button>

        <Button variant="text" size='large'
          startIcon={<RuleFolderOutlinedIcon />}
          onClick={handleOpenValidateScheduleDialog}>
          Validate Schedule File
        </Button>

        <Button variant="text" size='large'
          startIcon={<TheaterComedyOutlinedIcon />}
          onClick={handleOpenConvertScheduleDialog}>
          Convert Legacy Schedule
        </Button>

        <Button variant="text" size='large' color='secondary'
          startIcon={<PrivacyTipIcon />} onClick={handlePrivacyMenu}>
          Privacy Notice
        </Button>

        <PrivacyNoticeDialog
          open={openPrivacyNoticeDialog}
          handleClose={handleClosePrivacyNotice}
        />

        {/* <Button variant="text" size='large'
          startIcon={<DriveFolderUploadOutlinedIcon />}
          onClick={openProject}>
          Import Project
        </Button> */}
      </Stack>

      <OpenFileDialog open={openProjectFileDialog}
        handleOpen={handleProject}
        handleCancel={handleCancelOpenProject}
        itemSelectionAllowed={itemSelectionAllowed}
      />

      <CreateFileDialog open={openCreateProjectFileDialog}
        handleCreate={handleProject}
        handleCancel={handleCancelCreateProject}
        itemSelectionAllowed={itemCreateSelectionAllowed}
      />      
    </Stack>
  )
}
